export default "__VITE_ASSET__C7tfyl0d__"